import { render, staticRenderFns } from "./allfamilymember.vue?vue&type=template&id=bf18f842&scoped=true"
import script from "./allfamilymember.vue?vue&type=script&lang=js"
export * from "./allfamilymember.vue?vue&type=script&lang=js"
import style0 from "./allfamilymember.vue?vue&type=style&index=0&id=bf18f842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf18f842",
  null
  
)

export default component.exports